import { createReducer, on } from "@ngrx/store";
import * as action from "./auth.actions";
import {Business, DesignProject, NewUser, OperationTypes} from "../../auth/models/login.model";

export interface AuthState {
	user: NewUser | null;
	clients: Business[];
	designProjects: DesignProject[]
}

export const initialState: AuthState = {
	user: null,
	clients: [],
	designProjects: []
}

export const authReducer = createReducer(
	initialState,
	on(action.setUser, (state, {user}) => ({ ...state, user})),
	on(action.logOut, (state) => ({...state, ...initialState})),
	on(action.setClients, (state, {clients}) => ({ ...state, clients})),
	on(action.setDesingProjects, (state, {designs}) => ({ ...state, designProjects: designs})),
)
